import ReactDOM from 'react-dom/client';
import React from 'react';
import './index.css';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import { load } from '@cashfreepayments/cashfree-js';
const root = ReactDOM.createRoot(document.getElementById('root'));
let cashfree;
const initializeSDK = async () => {
    try {
        cashfree = await load({
            mode: 'production',
        });
        console.log('Cashfree SDK initialized successfully', cashfree);
    } catch (error) {
        console.error('Failed to initialize Cashfree SDK', error);
    }
};
initializeSDK();
root.render(
  <React.StrictMode>
    <Provider store={store} >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();